import React from 'react';
import {
	Breadcrumb,
	Card,
	Row,
	Col,
	Button,
	message,
	Select,
	Spin,
	Form,
	Alert,
	Statistic,
	Table,
	Tag,
	Divider,
	Tooltip,
	Typography,
	Checkbox,
	Progress,
} from 'antd';
import {
	LineChartOutlined,
	SearchOutlined,
	InfoCircleOutlined,
	ArrowUpOutlined,
	ArrowDownOutlined,
	RobotOutlined,
	BarChartOutlined,
} from '@ant-design/icons';
import { Bar, Line } from 'react-chartjs-2';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import Cookies from 'js-cookie';

const configClass = {
	title: 'Proyeksi Potensi PKB',
	apiUrl: {
		proyeksi: 'analitik/api/proyeksi-potensi-pkb/',
		aiAnalisa: 'analitik/api/ai-analisa/',
		kabupaten: 'master/api/kabupaten/',
		upt: 'pegawai/api/upt/',
	},
	breadCrumb: [
		<span><LineChartOutlined /> Analitik</span>,
		'Proyeksi Potensi PKB',
	],
};

const config = new Config();

const formatRp = (val) => {
	if (!val && val !== 0) return '-';
	return 'Rp ' + Math.round(val).toLocaleString('id-ID');
};

const formatJumlah = (val) => {
	if (!val && val !== 0) return '-';
	return Math.round(val).toLocaleString('id-ID');
};

const GrowthTag = ({ persen }) => {
	if (persen === undefined || persen === null) return null;
	const positif = persen >= 0;
	return (
		<Tag color={positif ? 'green' : 'red'} style={{ marginLeft: 4 }}>
			{positif ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
			{Math.abs(persen)}%
		</Tag>
	);
};

const TAHUN_DEFAULT = new Date().getFullYear() - 1; // tahun lalu = data sudah lengkap

const tahunOptions = () => {
	const now = new Date().getFullYear();
	// Tampilkan dari tahun lalu ke bawah 4 tahun (data lengkap)
	// Serta tahun berjalan (tapi dengan peringatan)
	return Array.from({ length: 6 }, (_, i) => now - i);
};

class AnalisaPotensiPkb extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			data: null,

			loadingKabupaten: false,
			listKabupaten: [],

			loadingUpt: false,
			listUpt: [],

			filter: {},
			pemutihan_denda: false,
			pemutihan_tunggakan: false,

			loadingAi: false,
			analisisAi: null,
			errorAi: null,
			aiModel: null,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.loadKabupaten();
	}

	loadKabupaten() {
		this.setState({ loadingKabupaten: true });
		this.props
			.ajaxViewHandler('get', configClass.apiUrl.kabupaten)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({
						listKabupaten: data.results || data,
						loadingKabupaten: false,
					});
				} else {
					this.setState({ loadingKabupaten: false });
				}
			})
			.catch(() => this.setState({ loadingKabupaten: false }));
	}

	loadUpt(kabupatenId = '') {
		const url = kabupatenId
			? configClass.apiUrl.upt + '?kabupaten=' + kabupatenId
			: configClass.apiUrl.upt;
		this.setState({ loadingUpt: true });
		this.props
			.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({
						listUpt: data.results || data,
						loadingUpt: false,
					});
				} else {
					this.setState({ loadingUpt: false });
				}
			})
			.catch(() => this.setState({ loadingUpt: false }));
	}

	handleSubmit = (values) => {
		const params = {};
		if (values.tahun) params.tahun = values.tahun;
		if (values.kabupaten_id) params.kabupaten_id = values.kabupaten_id;
		if (values.upt_id) params.upt_id = values.upt_id;
		if (this.state.pemutihan_denda)     params.pemutihan_denda     = 'true';
		if (this.state.pemutihan_tunggakan) params.pemutihan_tunggakan = 'true';
		this.setState({ filter: params, analisisAi: null }, this.getData);
	};

	getData() {
		const { filter } = this.state;
		const query = Object.keys(filter)
			.map((k) => `${k}=${filter[k]}`)
			.join('&');
		const url = configClass.apiUrl.proyeksi + (query ? '?' + query : '');

		this.setState({ loading: true, data: null });
		this.props
			.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					this.setState({ data: this.props.responseMsg, loading: false });
				} else {
					message.error({ content: 'Gagal memuat data analitik', duration: 2, key: 'toast' });
					this.setState({ loading: false });
				}
			})
			.catch(() => {
				message.error({ content: 'Terjadi kesalahan, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loading: false });
			});
	}

	componentWillUnmount() {
		this._stopPolling();
	}

	_stopPolling() {
		if (this._pollTimer) {
			clearInterval(this._pollTimer);
			this._pollTimer = null;
		}
	}

	_pollStatus(taskId) {
		const token   = Cookies.get(config.get_cookie_name());
		const baseUrl = config.get_base_url().replace(/\/$/, '');
		const url     = `${baseUrl}/${configClass.apiUrl.aiAnalisa}?task_id=${taskId}`;

		fetch(url, { headers: { 'Authorization': token } })
			.then((res) => res.json())
			.then((res) => {
				if (res.status === 'done') {
					this._stopPolling();
					this.setState({ analisisAi: res.analisis, loadingAi: false, aiModel: res.model });
				} else if (res.status === 'error') {
					this._stopPolling();
					this.setState({ errorAi: res.error, loadingAi: false });
				}
				// status === 'processing' → lanjut polling
			})
			.catch((err) => {
				this._stopPolling();
				this.setState({ errorAi: err.message || 'Gagal cek status AI.', loadingAi: false });
			});
	}

	getAiAnalisa() {
		const { data } = this.state;
		if (!data) return;
		this._stopPolling();
		this.setState({ loadingAi: true, analisisAi: null, errorAi: null, aiModel: null });

		const token   = Cookies.get(config.get_cookie_name());
		const baseUrl = config.get_base_url().replace(/\/$/, '');
		const apiUrl  = `${baseUrl}/${configClass.apiUrl.aiAnalisa}`;

		fetch(apiUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Authorization': token },
			body: JSON.stringify(data),
		})
			.then((res) => {
				if (!res.ok) {
					return res.text().then((t) => { throw new Error(`HTTP ${res.status}: ${t.substring(0, 300)}`); });
				}
				return res.json();
			})
			.then((res) => {
				if (res.error) {
					this.setState({ errorAi: res.error, loadingAi: false });
					return;
				}
				// Mulai polling setiap 5 detik
				const taskId = res.task_id;
				this._pollTimer = setInterval(() => this._pollStatus(taskId), 5000);
				// Langsung cek sekali dulu tanpa nunggu 5 detik
				this._pollStatus(taskId);
			})
			.catch((err) => {
				console.error('[AI Analisa Error]', err);
				this.setState({ errorAi: err.message || 'Gagal menghubungi server AI.', loadingAi: false });
			});
	}

	buildChartKendaraanBaru() {
		const { data } = this.state;
		if (!data) return null;
		const { historis, proyeksi, tahun_proyeksi, realisasi_berjalan: real } = data;

		const labels = [
			...historis.map((h) => String(h.tahun)),
			`${tahun_proyeksi} (Proj)`,
			...(real ? [`${real.tahun} (${real.label})`] : []),
		];

		const getVal = (h, key) => h[key] ? h[key].jumlah : 0;
		const projVal = (key) => proyeksi[key] ? proyeksi[key].jumlah_estimasi : 0;
		const realVal = (key) => real && real[key] ? real[key].jumlah : null;

		return {
			labels,
			datasets: [
				{
					label: 'Pendaftaran Baru',
					backgroundColor: '#52c41a',
					data: [
						...historis.map((h) => getVal(h, 'pendaftaran_baru')),
						projVal('pendaftaran_baru'),
						...(real ? [realVal('pendaftaran_baru')] : []),
					],
				},
				{
					label: 'Mutasi Masuk Dalam',
					backgroundColor: '#13c2c2',
					data: [
						...historis.map((h) => getVal(h, 'mutasi_masuk_dalam')),
						projVal('mutasi_masuk_dalam'),
						...(real ? [realVal('mutasi_masuk_dalam')] : []),
					],
				},
				{
					label: 'Mutasi Masuk Luar',
					backgroundColor: '#722ed1',
					data: [
						...historis.map((h) => getVal(h, 'mutasi_masuk_luar')),
						projVal('mutasi_masuk_luar'),
						...(real ? [realVal('mutasi_masuk_luar')] : []),
					],
				},
			],
		};
	}

	buildChartKepatuhan() {
		const { data } = this.state;
		if (!data) return null;
		const { historis, proyeksi, tahun_proyeksi, realisasi_berjalan: real } = data;

		const labels = [
			...historis.map((h) => String(h.tahun)),
			`${tahun_proyeksi} (Proj)`,
			...(real ? [`${real.tahun} (${real.label})`] : []),
		];

		const getVal = (h) => h.kendaraan_lama ? h.kendaraan_lama.jumlah : 0;

		return {
			labels,
			datasets: [
				{
					label: 'Kendaraan Lama Bayar',
					borderColor: '#1890ff',
					backgroundColor: 'rgba(24,144,255,0.15)',
					pointBackgroundColor: '#1890ff',
					pointRadius: 5,
					fill: true,
					data: [
						...historis.map((h) => getVal(h)),
						proyeksi.kendaraan_lama ? proyeksi.kendaraan_lama.jumlah_estimasi : 0,
						...(real && real.kendaraan_lama ? [real.kendaraan_lama.jumlah] : []),
					],
				},
				...(real ? [{
					label: 'Realisasi Kendaraan Lama',
					borderColor: '#722ed1',
					backgroundColor: 'rgba(114,46,209,0.1)',
					pointBackgroundColor: '#722ed1',
					borderDash: [5, 5],
					pointRadius: 5,
					fill: false,
					data: [
						...historis.map(() => null),
						null,
						real.kendaraan_lama ? real.kendaraan_lama.jumlah : 0,
					],
				}] : []),
			],
		};
	}

	renderCharts() {
		const { data } = this.state;
		if (!data) return null;

		const chartOptions = {
			responsive: true,
			maintainAspectRatio: true,
			legend: { position: 'bottom' },
			scales: {
				yAxes: [{
					ticks: {
						callback: (val) => formatJumlah(val),
						beginAtZero: true,
					},
				}],
			},
		};

		const barData  = this.buildChartKendaraanBaru();
		const lineData = this.buildChartKepatuhan();

		return (
			<Row gutter={16} style={{ marginBottom: 16 }}>
				<Col xs={24} md={12}>
					<Card
						size="small"
						title={<span><BarChartOutlined style={{ marginRight: 6 }} />Pertumbuhan Kendaraan Baru per Tahun</span>}
					>
						<Bar data={barData} options={{ ...chartOptions, scales: { yAxes: [{ stacked: false, ticks: { callback: (v) => formatJumlah(v), beginAtZero: true } }] } }} height={200} />
					</Card>
				</Col>
				<Col xs={24} md={12}>
					<Card
						size="small"
						title={<span><LineChartOutlined style={{ marginRight: 6 }} />Tingkat Kepatuhan Kendaraan Lama (Jumlah Bayar)</span>}
					>
						<Line data={lineData} options={chartOptions} height={200} />
					</Card>
				</Col>
			</Row>
		);
	}

	renderAiAnalisa() {
		const { data, loadingAi, analisisAi, errorAi, aiModel } = this.state;
		if (!data) return null;

		const modelLabel = aiModel || 'Ollama';

		return (
			<Card
				size="small"
				title={
					<span>
						<RobotOutlined style={{ marginRight: 6 }} />
						Analisis AI
						{aiModel && (
							<Tag color="purple" style={{ marginLeft: 8, fontSize: 11 }}>
								{aiModel}
							</Tag>
						)}
					</span>
				}
				style={{ marginBottom: 16 }}
				extra={
					<Button
						type="primary"
						icon={<RobotOutlined />}
						loading={loadingAi}
						onClick={() => this.getAiAnalisa()}
						size="small"
						disabled={loadingAi}
					>
						{analisisAi ? 'Buat Ulang Analisis' : 'Buat Analisis AI'}
					</Button>
				}
			>
				{!analisisAi && !loadingAi && !errorAi && (
					<div style={{ textAlign: 'center', padding: '24px 0', color: '#999' }}>
						<RobotOutlined style={{ fontSize: 32, marginBottom: 8 }} />
						<div>
							Klik <strong>Buat Analisis AI</strong> untuk mendapatkan interpretasi otomatis.
							<br />
							<span style={{ fontSize: 12 }}>
								Proses berjalan di background — kamu bisa tetap scroll halaman sambil menunggu.
							</span>
						</div>
					</div>
				)}
				{loadingAi && (
					<div style={{ textAlign: 'center', padding: '24px 0' }}>
						<Spin size="large" />
						<div style={{ marginTop: 12, color: '#666' }}>
							<strong>Ollama sedang memproses...</strong>
							<br />
							<span style={{ fontSize: 12 }}>
								Berjalan di background, halaman akan update otomatis saat selesai.
								Tidak perlu menunggu di halaman ini.
							</span>
						</div>
					</div>
				)}
				{errorAi && (
					<Alert type="error" message="Gagal" description={errorAi} showIcon />
				)}
				{analisisAi && (
					<Typography.Paragraph
						style={{ whiteSpace: 'pre-wrap', marginBottom: 0, lineHeight: 1.8 }}
					>
						{analisisAi}
					</Typography.Paragraph>
				)}
			</Card>
		);
	}

	renderPemutihanBanner() {
		const { data } = this.state;
		if (!data || !data.proyeksi_pemutihan) return null;
		const pm      = data.proyeksi_pemutihan;
		const pmTotal = pm.data && pm.data.total ? pm.data.total : {};
		const norTotal = data.proyeksi && data.proyeksi.total ? data.proyeksi.total : {};
		const selisihPkb = (pmTotal.estimasi_pkb || 0) - (norTotal.estimasi_pkb || 0);
		const selisihJml = (pmTotal.jumlah_estimasi || 0) - (norTotal.jumlah_estimasi || 0);
		const pctBoost   = norTotal.estimasi_pkb > 0
			? (((pmTotal.estimasi_pkb || 0) / norTotal.estimasi_pkb) * 100 - 100).toFixed(1)
			: 0;

		return (
			<Card
				size="small"
				style={{ marginBottom: 16, borderColor: '#faad14', background: '#fffbe6' }}
				title={
					<span style={{ color: '#d48806' }}>
						🏷️ Skenario Pemutihan: <strong>{pm.keterangan}</strong>
					</span>
				}
			>
				<Row gutter={16}>
					<Col xs={24} sm={8}>
						<Statistic
							title="Estimasi PKB dengan Pemutihan"
							value={pmTotal.estimasi_pkb || 0}
							formatter={(v) => formatRp(v)}
							valueStyle={{ color: '#d48806', fontSize: 15 }}
						/>
						<div style={{ fontSize: 12, marginTop: 4 }}>
							+{formatRp(selisihPkb)} dibanding proyeksi normal&nbsp;
							<Tag color="gold">+{pctBoost}%</Tag>
						</div>
					</Col>
					<Col xs={24} sm={8}>
						<Statistic
							title="Estimasi Kendaraan dengan Pemutihan"
							value={pmTotal.jumlah_estimasi || 0}
							formatter={(v) => formatJumlah(v)}
							valueStyle={{ color: '#d48806', fontSize: 15 }}
						/>
						<div style={{ fontSize: 12, marginTop: 4 }}>
							+{formatJumlah(selisihJml)} kendaraan tambahan
						</div>
					</Col>
					<Col xs={24} sm={8}>
						<div style={{ paddingTop: 4 }}>
							<div style={{ fontSize: 12, marginBottom: 6, color: '#666' }}>
								Boost kepatuhan kendaraan lama vs proyeksi normal:
							</div>
							<Progress
								percent={parseFloat(pctBoost)}
								strokeColor="#faad14"
								format={(p) => `+${p}%`}
								size="small"
							/>
						</div>
					</Col>
				</Row>
				<div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
					💡 Multiplier yang digunakan: ×{pm.multiplier_lama} untuk kendaraan lama.
					Angka ini didasarkan pada rata-rata dampak pemutihan PKB di provinsi-provinsi Indonesia.
					Hasil aktual dapat bervariasi tergantung intensitas sosialisasi dan durasi program.
				</div>
			</Card>
		);
	}

	renderFilterForm() {
		return (
			<Card size="small" style={{ marginBottom: 16 }}>
				<Form
					ref={this.formRef}
					layout="inline"
					onFinish={this.handleSubmit}
					initialValues={{ tahun: TAHUN_DEFAULT }}
				>
					<Form.Item label="Tahun Analisis" name="tahun">
						<Select style={{ width: 120 }}>
							{tahunOptions().map((y) => {
								const isBerjalan = y === new Date().getFullYear();
								return (
									<Select.Option key={y} value={y}>
										{y}{isBerjalan ? ' ⚠ (berjalan)' : ''}
									</Select.Option>
								);
							})}
						</Select>
					</Form.Item>

					<Form.Item label="Kabupaten" name="kabupaten_id">
						<Select
							showSearch
							allowClear
							placeholder="Semua Kabupaten"
							style={{ width: 200 }}
							loading={this.state.loadingKabupaten}
							optionFilterProp="children"
							onChange={(val) => {
								if (this.formRef.current) {
									this.formRef.current.setFieldsValue({ upt_id: undefined });
								}
								this.loadUpt(val || '');
							}}
						>
							{(this.state.listKabupaten.results || this.state.listKabupaten).map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.name}
								</Select.Option>
							))}
						</Select>
					</Form.Item>

					<Form.Item label="UPT" name="upt_id">
						<Select
							showSearch
							allowClear
							placeholder="Semua UPT"
							style={{ width: 200 }}
							loading={this.state.loadingUpt}
							optionFilterProp="children"
						>
							{(this.state.listUpt.results || this.state.listUpt).map((item) => (
								<Select.Option key={item.id} value={item.id}>
									{item.nama}
								</Select.Option>
							))}
						</Select>
					</Form.Item>

					<Form.Item label="Skenario Pemutihan">
						<Checkbox
							checked={this.state.pemutihan_denda}
							onChange={(e) => this.setState({ pemutihan_denda: e.target.checked })}
							style={{ marginRight: 16 }}
						>
							Pemutihan Denda PKB
						</Checkbox>
						<Checkbox
							checked={this.state.pemutihan_tunggakan}
							onChange={(e) => this.setState({ pemutihan_tunggakan: e.target.checked })}
						>
							Pemutihan Tunggakan PKB
						</Checkbox>
					</Form.Item>

					<Form.Item>
						<Button
							type="primary"
							htmlType="submit"
							icon={<SearchOutlined />}
							loading={this.state.loading}
						>
							Analisa
						</Button>
					</Form.Item>
				</Form>
			</Card>
		);
	}

	renderSummaryCards() {
		const { data } = this.state;
		if (!data) return null;

		const { proyeksi, tahun_analisis, tahun_proyeksi, realisasi_berjalan: real } = data;
		const total = proyeksi.total;
		const pctPkb  = real ? real.persen_pencapaian_pkb  : null;
		const pctJml  = real ? real.persen_pencapaian_jml  : null;
		const colMd   = real ? 4 : 6;

		return (
			<>
				<Row gutter={16} style={{ marginBottom: 8 }}>
					<Col xs={24} sm={12} md={colMd}>
						<Card size="small">
							<Statistic
								title={`Proyeksi PKB ${tahun_proyeksi} (Estimasi)`}
								value={total.estimasi_pkb}
								formatter={(val) => formatRp(val)}
								valueStyle={{ color: '#1890ff', fontSize: 15 }}
								prefix={<LineChartOutlined />}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={colMd}>
						<Card size="small">
							<Statistic
								title={`Est. Kendaraan Bayar ${tahun_proyeksi}`}
								value={total.jumlah_estimasi}
								formatter={(val) => formatJumlah(val)}
								valueStyle={{ color: '#52c41a', fontSize: 15 }}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={colMd}>
						<Card size="small">
							<Statistic
								title={`Realisasi PKB ${tahun_analisis}`}
								value={data.historis[2] && data.historis[2].total ? data.historis[2].total.total_pkb : 0}
								formatter={(val) => formatRp(val)}
								valueStyle={{ fontSize: 15 }}
							/>
						</Card>
					</Col>
					<Col xs={24} sm={12} md={colMd}>
						<Card size="small">
							<Statistic
								title="Pertumbuhan YoY Rata-rata"
								value={data.pertumbuhan_persen.kendaraan_lama}
								suffix="%"
								precision={2}
								valueStyle={{
									color: data.pertumbuhan_persen.kendaraan_lama >= 0 ? '#52c41a' : '#ff4d4f',
									fontSize: 15,
								}}
								prefix={data.pertumbuhan_persen.kendaraan_lama >= 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
							/>
						</Card>
					</Col>
					{real && (
						<>
							<Col xs={24} sm={12} md={colMd}>
								<Card
									size="small"
									style={{ borderColor: pctPkb >= 50 ? '#52c41a' : '#faad14' }}
								>
									<Statistic
										title={`Realisasi PKB ${real.tahun} (${real.label})`}
										value={real.total_potensi ? real.total_potensi.total_pkb : 0}
										formatter={(val) => formatRp(val)}
										valueStyle={{ color: '#722ed1', fontSize: 15 }}
									/>
									<div style={{ marginTop: 4, fontSize: 12, color: '#666' }}>
										Pencapaian vs Proyeksi:&nbsp;
										<Tag color={pctPkb >= 50 ? 'green' : 'orange'}>
											{pctPkb}%
										</Tag>
									</div>
								</Card>
							</Col>
							<Col xs={24} sm={12} md={colMd}>
								<Card
									size="small"
									style={{ borderColor: pctJml >= 50 ? '#52c41a' : '#faad14' }}
								>
									<Statistic
										title={`Kendaraan Bayar ${real.tahun} (${real.label})`}
										value={real.total_potensi ? real.total_potensi.jumlah : 0}
										formatter={(val) => formatJumlah(val)}
										valueStyle={{ color: '#722ed1', fontSize: 15 }}
									/>
									<div style={{ marginTop: 4, fontSize: 12, color: '#666' }}>
										Pencapaian vs Proyeksi:&nbsp;
										<Tag color={pctJml >= 50 ? 'green' : 'orange'}>
											{pctJml}%
										</Tag>
									</div>
								</Card>
							</Col>
						</>
					)}
				</Row>
			</>
		);
	}

	renderHistorisTable() {
		const { data } = this.state;
		if (!data) return null;

		const { historis, proyeksi, tahun_proyeksi, pertumbuhan_persen, realisasi_berjalan: real } = data;
		const [tMin2, tMin1, tSini] = historis;

		const KATEGORI = [
			{
				key: 'kendaraan_lama',
				label: 'Kendaraan Lama',
				deskripsi: 'Perpanjangan, tidak ada BBNKB',
				warna: '#1890ff',
			},
			{
				key: 'pendaftaran_baru',
				label: 'Pendaftaran Baru',
				deskripsi: 'Kendaraan baru pertama kali daftar (kode layanan 01)',
				warna: '#52c41a',
			},
			{
				key: 'mutasi_masuk_dalam',
				label: 'Mutasi Masuk Dalam Provinsi',
				deskripsi: 'Kendaraan pindah masuk dari kabupaten lain dalam provinsi',
				warna: '#13c2c2',
			},
			{
				key: 'mutasi_masuk_luar',
				label: 'Mutasi Masuk Luar Provinsi',
				deskripsi: 'Kendaraan pindah masuk dari luar provinsi',
				warna: '#722ed1',
			},
			{
				key: 'mutasi_keluar_luar',
				label: 'Mutasi Keluar Luar Provinsi',
				deskripsi: 'Kendaraan meninggalkan provinsi (dikurangi dari potensi)',
				warna: '#ff4d4f',
				minus: true,
			},
			{
				key: 'mutasi_keluar_dalam',
				label: 'Mutasi Keluar Dalam Provinsi',
				deskripsi: 'Kendaraan pindah ke kabupaten lain dalam provinsi (netral untuk total provinsi)',
				warna: '#fa8c16',
				minus: false,
				netral: true,
			},
		];

		const labelSumber = (h) => (
			<span>
				{h.tahun}
				<Tag
					color={h.sumber === 'old' ? 'orange' : 'blue'}
					style={{ marginLeft: 4, fontSize: 10, padding: '0 4px' }}
				>
					{h.sumber === 'old' ? 'DB Lama' : 'DB Baru'}
				</Tag>
			</span>
		);

		const columns = [
			{
				title: 'Kategori Kendaraan',
				dataIndex: 'label',
				key: 'label',
				width: 220,
				render: (text, record) => (
					<Tooltip title={record.deskripsi}>
						<span style={{ color: record.warna, fontWeight: 600 }}>
							{record.minus && '(-) '}
							{record.netral && '(~) '}
							{text}
						</span>
					</Tooltip>
				),
			},
			{
				title: labelSumber(tMin2),
				children: [
					{
						title: 'Kendaraan',
						dataIndex: ['h0', 'jumlah'],
						key: `${tMin2.tahun}_jml`,
						align: 'right',
						render: formatJumlah,
					},
					{
						title: 'Total Bayar (Rp)',
						dataIndex: ['h0', 'total_pkb'],
						key: `${tMin2.tahun}_pkb`,
						align: 'right',
						render: formatRp,
					},
				],
			},
			{
				title: labelSumber(tMin1),
				children: [
					{
						title: 'Kendaraan',
						dataIndex: ['h1', 'jumlah'],
						key: `${tMin1.tahun}_jml`,
						align: 'right',
						render: formatJumlah,
					},
					{
						title: 'Total Bayar (Rp)',
						dataIndex: ['h1', 'total_pkb'],
						key: `${tMin1.tahun}_pkb`,
						align: 'right',
						render: formatRp,
					},
				],
			},
			{
				title: labelSumber(tSini),
				children: [
					{
						title: 'Kendaraan',
						dataIndex: ['h2', 'jumlah'],
						key: `${tSini.tahun}_jml`,
						align: 'right',
						render: formatJumlah,
					},
					{
						title: 'Total Bayar (Rp)',
						dataIndex: ['h2', 'total_pkb'],
						key: `${tSini.tahun}_pkb`,
						align: 'right',
						render: formatRp,
					},
				],
			},
			{
				title: 'Growth',
				dataIndex: 'growth',
				key: 'growth',
				align: 'center',
				render: (val) => <GrowthTag persen={val} />,
			},
			{
				title: `Proyeksi ${tahun_proyeksi} (Estimasi)`,
				children: [
					{
						title: 'Est. Kendaraan',
						dataIndex: ['proj', 'jumlah_estimasi'],
						key: 'proj_jml',
						align: 'right',
						render: (val, record) => (
							<span style={{ color: record.warna, fontWeight: 600 }}>
								{formatJumlah(val)}
							</span>
						),
					},
					{
						title: 'Est. PKB (Rp)',
						dataIndex: ['proj', 'estimasi_pkb'],
						key: 'proj_pkb',
						align: 'right',
						render: (val, record) => (
							<span style={{ color: record.warna, fontWeight: 600 }}>
								{formatRp(val)}
							</span>
						),
					},
				],
			},
			...(real ? [{
				title: (
					<span>
						Realisasi {real.tahun}&nbsp;
						<Tag color="purple" style={{ fontSize: 10, padding: '0 4px' }}>
							{real.label}
						</Tag>
					</span>
				),
				children: [
					{
						title: 'Kendaraan',
						dataIndex: ['real', 'jumlah'],
						key: 'real_jml',
						align: 'right',
						render: formatJumlah,
					},
					{
						title: 'Total Bayar (Rp)',
						dataIndex: ['real', 'total_pkb'],
						key: 'real_pkb',
						align: 'right',
						render: formatRp,
					},
					{
						title: '% Capai',
						key: 'real_pct',
						align: 'center',
						render: (_, record) => {
							const proj_pkb = record.proj ? record.proj.estimasi_pkb : 0;
							const real_pkb = record.real ? record.real.total_pkb : 0;
							if (!proj_pkb) return '-';
							const pct = (real_pkb / proj_pkb * 100).toFixed(1);
							return (
								<Tag color={pct >= 50 ? 'green' : pct >= 30 ? 'orange' : 'red'}>
									{pct}%
								</Tag>
							);
						},
					},
				],
			}] : []),
		];

		const dataSource = KATEGORI.map((kat) => ({
			...kat,
			h0: tMin2[kat.key],
			h1: tMin1[kat.key],
			h2: tSini[kat.key],
			growth: pertumbuhan_persen[kat.key],
			proj: proyeksi[kat.key],
			real: real ? real[kat.key] : null,
		}));

		// Baris total
		const totalRow = {
			key: 'total',
			label: 'TOTAL POTENSI',
			deskripsi: 'Total estimasi PKB tahun proyeksi (lama + masuk - keluar luar provinsi)',
			warna: '#262626',
			h0: tMin2.total,
			h1: tMin1.total,
			h2: tSini.total,
			growth: null,
			proj: proyeksi.total,
			real: real ? real.total_potensi : null,
		};

		return (
			<Card
				title={
					<span>
						<LineChartOutlined style={{ marginRight: 8 }} />
						Historis & Proyeksi per Kategori Kendaraan
					</span>
				}
				size="small"
				style={{ marginBottom: 16 }}
			>
				<Table
					columns={columns}
					dataSource={[...dataSource, totalRow]}
					rowKey="key"
					pagination={false}
					size="small"
					bordered
					rowClassName={(record) =>
						record.key === 'total' ? 'ant-table-row-total' : ''
					}
					style={{ overflowX: 'auto' }}
					summary={() => null}
				/>
				<style>{`
					.ant-table-row-total td {
						background: #f0f5ff !important;
						font-weight: bold;
					}
				`}</style>
			</Card>
		);
	}

	renderCatatan() {
		const { data } = this.state;
		if (!data) return null;

		const adaDataLama = data.historis && data.historis.some((h) => h.sumber === 'old');
		const tahunBerjalan = new Date().getFullYear();
		const dataTahunBerjalan = data.historis && data.historis.find(
			(h) => h.tahun === tahunBerjalan
		);

		return (
			<Row gutter={[16, 8]}>
				{dataTahunBerjalan && (
					<Col span={24}>
						<Alert
							type="error"
							showIcon
							icon={<InfoCircleOutlined />}
							message={`⚠ Perhatian: Data Tahun ${tahunBerjalan} Belum Lengkap`}
							description={
								`Historis mencakup tahun ${tahunBerjalan} yang masih berjalan ` +
								`(data hanya tersedia sampai bulan ${new Date().toLocaleString('id-ID', { month: 'long' })} ${tahunBerjalan}). ` +
								`Proyeksi tahun ${tahunBerjalan + 1} akan tidak akurat karena data dasar belum lengkap. ` +
								`Disarankan menggunakan Tahun Analisis ${tahunBerjalan - 1} agar proyeksi dihitung dari data tahun penuh.`
							}
						/>
					</Col>
				)}
				{adaDataLama && (
					<Col span={24}>
						<Alert
							type="warning"
							showIcon
							icon={<InfoCircleOutlined />}
							message="Catatan Data Historis"
							description={data.catatan && data.catatan.sumber_data}
						/>
					</Col>
				)}
				{adaDataLama && (
					<Col span={24}>
						<Alert
							type="info"
							showIcon
							icon={<InfoCircleOutlined />}
							message="Filter Wilayah Data Lama"
							description={data.catatan && data.catatan.filter_wilayah_old}
						/>
					</Col>
				)}
				<Col xs={24} md={12}>
					<Alert
						type="warning"
						showIcon
						icon={<InfoCircleOutlined />}
						message="Perlakuan Mutasi Keluar Luar Provinsi"
						description={
							data.proyeksi.mutasi_keluar_luar
								? data.proyeksi.mutasi_keluar_luar.keterangan
								: null
						}
					/>
				</Col>
				<Col xs={24} md={12}>
					<Alert
						type="info"
						showIcon
						icon={<InfoCircleOutlined />}
						message="Perlakuan Mutasi Keluar Dalam Provinsi"
						description={
							data.proyeksi.mutasi_keluar_dalam
								? data.proyeksi.mutasi_keluar_dalam.keterangan
								: null
						}
					/>
				</Col>
				<Col span={24}>
					<Alert
						type="success"
						showIcon
						message="Metode Proyeksi"
						description={data.catatan && data.catatan.metode}
					/>
				</Col>
			</Row>
		);
	}

	render() {
		const { loading, data } = this.state;
		return (
			<div>
				<Helmet>
					<title>{configClass.title} | Aplikasi</title>
				</Helmet>
				<Breadcrumb style={{ marginBottom: 16 }}>
					{configClass.breadCrumb.map((item, i) => (
						<Breadcrumb.Item key={i}>{item}</Breadcrumb.Item>
					))}
				</Breadcrumb>

				<Card
					title={
						<span>
							<LineChartOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</span>
					}
					size="small"
					style={{ marginBottom: 16 }}
				>
					<p style={{ margin: 0, color: '#666' }}>
						Analisis historis pembayaran PKB dan proyeksi potensi penerimaan tahun berikutnya.
						Data dipisah berdasarkan kategori kendaraan: lama, pendaftaran baru, mutasi masuk,
						dan mutasi keluar.
					</p>
				</Card>

				{this.renderFilterForm()}

				<Spin spinning={loading} tip="Memproses data analitik...">
					{!data && !loading && (
						<Card>
							<div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
								<LineChartOutlined style={{ fontSize: 48, marginBottom: 16 }} />
								<div>Pilih parameter dan klik tombol <strong>Analisa</strong> untuk melihat proyeksi potensi PKB</div>
							</div>
						</Card>
					)}

					{data && (
						<>
							{this.renderSummaryCards()}
							{this.renderPemutihanBanner()}
							{this.renderCharts()}
							{this.renderHistorisTable()}
							{this.renderAiAnalisa()}
							<Divider />
							{this.renderCatatan()}
						</>
					)}
				</Spin>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler,
	ajaxViewHandler,
	setConfig,
})(AnalisaPotensiPkb);
